"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var BaseDialog = (0, material_1.styled)(material_1.Dialog)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(material_1.dialogTitleClasses.root)] = {
            paddingTop: theme.spacing(3),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            paddingBottom: theme.spacing(2)
        },
        _b[".".concat(material_1.dialogContentClasses.root)] = {
            paddingTop: 0,
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            paddingBottom: theme.spacing(3)
        },
        _b[".".concat(material_1.dialogActionsClasses.root)] = (_c = {
                paddingTop: 0,
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5),
                paddingBottom: theme.spacing(4)
            },
            _c["> .".concat(material_1.buttonClasses.root, ":not(.no-pad)")] = {
                fontSize: '0.75rem',
                fontWeight: '600',
                padding: '7px 16px 5px'
            },
            _c),
        _b);
});
var StyledDialog = function (props) {
    // the other possible reason is 'backdropClicked' and we want to filter those events
    var onCloseOverride = function (event, reason) {
        var _a;
        if (reason === 'escapeKeyDown') {
            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, event, reason);
        }
    };
    return (react_1.default.createElement(BaseDialog, __assign({}, props, { onClose: onCloseOverride }), props.children));
};
exports.default = StyledDialog;
